module.exports = __webpack_public_path__ + "img/goldregen-2020-113.5a5c1adf.jpg";